import "./SideMenu.css";

export const SideMenu = ({ setSelectedStore }) => {
  return (
    <div className="side-menu ">
      <div className="sidebar-header">
        <img
          className="sidebar-logo"
          src="/icons/logo.png"
          alt="FlipNDeals Logo"
        />
        <div className="sidebar-title">FlipNDeals</div>
        <div className="version-info">v.01</div>
      </div>

      <ul className="menu-list">
        <li className="menu-item">
          <img
            className="menu-icon"
            src="/icons/home.svg"
            alt="Dashboard"
          />
          <span className="menu-text">Dashboard</span>
        </li>
        <li className="menu-item" onClick={() => setSelectedStore("walmart")}>
          <img className="menu-icon" src="/icons/walmart.svg" alt="Walmart" />
          <span className="menu-text">Walmart</span>
          <img
            className="chevron-icon"
            src="/icons/chevron-right 2.png"
            alt="Arrow"
          />
        </li>
        <li className="menu-item" onClick={() => setSelectedStore("bjs")}>
          <img className="menu-icon" src="/icons/bjs.svg" alt="BJs" />
          <span className="menu-text">BJs</span>
          <img
            className="chevron-icon"
            src="/icons/chevron-right 2.png"
            alt="Arrow"
          />
        </li>
        <li className="menu-item" onClick={() => setSelectedStore("target")}>
          <img className="menu-icon" src="/icons/target.svg" alt="Target" />
          <span className="menu-text">Target</span>
          <img
            className="chevron-icon"
            src="/icons/chevron-right 2.png"
            alt="Arrow"
          />
        </li>
        <li className="menu-item" onClick={() => setSelectedStore("amazon")}>
          <img className="menu-icon" src="/icons/amazon.svg" alt="Amazon" />
          <span className="menu-text">Amazon</span>
          <img
            className="chevron-icon"
            src="/icons/chevron-right 2.png"
            alt="Arrow"
          />
        </li>
        <li className="menu-item" onClick={() => setSelectedStore("homedepot")}>
          <img className="menu-icon" src="/icons/hd.svg" alt="Home Depot" />
          <span className="menu-text">Home Depot</span>
          <img
            className="chevron-icon"
            src="/icons/chevron-right 2.png"
            alt="Arrow"
          />
        </li>
        <li className="menu-item" onClick={() => setSelectedStore("lowes")}>
          <img className="menu-icon" src="/icons/lowes.svg" alt="Lowes" />
          <span className="menu-text">Lowes</span>
          <img
            className="chevron-icon"
            src="/icons/chevron-right 2.png"
            alt="Arrow"
          />
        </li>
        <li className="menu-item" onClick={() => setSelectedStore("samsclub")}>
          <img className="menu-icon" src="/icons/sams.svg" alt="Sam's Club" />
          <span className="menu-text">Sam's Club</span>
          <img
            className="chevron-icon"
            src="/icons/chevron-right 2.png"
            alt="Arrow"
          />
        </li>
      </ul>

      <div className="sidebar-footer">
        <div className="profile-info">
          <img
            className="profile-icon"
            src="/icons/profile.png"
            alt="Profile"
          />
          <div>
            <div className="profile-name">George</div>
            <div className="profile-role">FlipNMember</div>
          </div>
          <img
            className="dropdown-icon"
            src="/icons/downArrow.png"
            alt="Dropdown Arrow"
          />
        </div>
      </div>
    </div>
  );
};
